import { render, staticRenderFns } from "./NestedCheckboxFacet.vue?vue&type=template&id=354a7560&scoped=true"
import script from "./NestedCheckboxFacet.vue?vue&type=script&lang=ts"
export * from "./NestedCheckboxFacet.vue?vue&type=script&lang=ts"
import style0 from "./NestedCheckboxFacet.vue?vue&type=style&index=0&id=354a7560&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a7560",
  null
  
)

export default component.exports